import { useEffect, useState } from "react";

export const useCountdown = (seconds) => {
  const [left, setLeft] = useState(seconds || 0);
  useEffect(() => setLeft(seconds || 0), [seconds]);
  useEffect(() => {
    if (!left) return undefined;
    const id = setInterval(() => setLeft((v) => Math.max(v - 1, 0)), 1000);
    return () => clearInterval(id);
  }, [left]);
  const h = Math.floor(left / 3600);
  const m = Math.floor((left % 3600) / 60);
  const s = left % 60;
  return { left, label: `${h}h ${String(m).padStart(2, "0")}m ${String(s).padStart(2, "0")}s` };
};

export const Countdown = ({ seconds, testid = "cutoff-countdown" }) => {
  const { label } = useCountdown(seconds);
  return (
    <span data-testid={testid} className="tabular">
      {label}
    </span>
  );
};

export default Countdown;
